export const FirebaseConfig = {
	"projectId": "manur1",
	"appId": "1:467244263862:web:1258eefd0fda53b351f917",
	"databaseURL": "https://manur1-default-rtdb.firebaseio.com",
	"storageBucket": "manur1.firebasestorage.app",
	"apiKey": "AIzaSyCpiEYzLPo5HrMtemw-c4K4QHs5-Ea9Kw4",
	"authDomain": "manur1.firebaseapp.com",
	"messagingSenderId": "467244263862",
	"measurementId": "G-C9XDG267FE"
};